export default __webpack_public_path__ + "static/media/agribusiness.83d83369.png";